import { Modal } from '@chronosphereio/chrono-ui';
import { useDeletePanelGroupDialog } from '../../context';

export const DeletePanelGroupDialog = () => {
  const { deletePanelGroupDialog, closeDeletePanelGroupDialog, deletePanelGroup } = useDeletePanelGroupDialog();

  const panelGroupId = deletePanelGroupDialog?.panelGroupId;

  const handleDelete = () => {
    if (panelGroupId == undefined) {
      throw new Error('group index is undefined');
    }
    deletePanelGroup(panelGroupId);
    closeDeletePanelGroupDialog();
  };

  return (
    <Modal
      open={deletePanelGroupDialog !== undefined}
      title="Delete panel group"
      onClose={closeDeletePanelGroupDialog}
      onPrimaryButtonClick={handleDelete}
      primaryButtonText="Delete"
      primaryButtonDanger
      size="small"
    >
      Are you sure you want to delete
      {deletePanelGroupDialog?.panelGroupName ? ` "${deletePanelGroupDialog.panelGroupName}"` : ' this panel group'}?
      This will delete all the panels within the group.
    </Modal>
  );
};
